import styled from 'styled-components';

import { ICON_SIZE } from './RecordingIcon.hooks';

export const StyledRecordingIcon = styled.div`
   position: relative;
   width: ${ICON_SIZE}px;
   height: ${ICON_SIZE}px;
   line-height: 0;
`;

StyledRecordingIcon.displayName = 'StyledRecordingIcon';

export const StyledCanvas = styled.canvas`
   position: absolute;
   inset: 0;
   width: ${ICON_SIZE}px;
   height: ${ICON_SIZE}px;
`;

StyledCanvas.displayName = 'StyledCanvas';

export const StyledSvg = styled.svg`
   display: block;
`;

StyledSvg.displayName = 'StyledSvg';
